var _rect, _path, _circle, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreditCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 56 56"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 46,
  x: 5,
  y: 41,
  stroke: "currentColor",
  strokeWidth: 2,
  rx: 4,
  transform: "rotate(-90 5 41)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M5 20h46M5 25h46"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 33,
  r: 4,
  stroke: "currentColor",
  transform: "rotate(-180 43 33)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M40.857 35.8a4 4 0 1 1 0-5.599"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 8,
  x: 9.5,
  y: 28.5,
  stroke: "currentColor",
  rx: 2.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M10 34h3M16 34h3M10 31h3M16 31h3"
})));
export default SvgCreditCard;